import React, { useState, useEffect } from "react";
import Sidebar from './composant_reutilisable/sidebar';
import Navbar from "./composant_reutilisable/navbar";
// import { Link } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";
import {
    FaEdit, FaEllipsisV,
    FaSortAmountUp, FaSortAmountDown,
    FaArrowLeft, FaArrowRight,
    FaCalendarCheck, FaFilter,
    FaCheck,
    FaTimes,
    FaFileExport
} from "react-icons/fa";
// import { useNavigate } from 'react-router-dom';

const Reservation = () => {
    // const navigate = useNavigate();

    const [isLoading, setIsLoading] = useState(false);
    const [sortConfig, setSortConfig] = useState({
        key: "-id",
        direction: "descending",
    });
    const user_id = localStorage.getItem('userId');
    const [alert, setAlert] = useState({ message: '', type: '' });
    const [alertModal, setAlertModal] = useState({ message: '', type: '' });

    const [booking, setBooking] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showModifierModal, setShowModifierModal] = useState(false);
    const [openDropdownId, setOpenDropdownId] = useState(null);

    // FILTRES
    const [statutFilter, setStatutFilter] = useState('tous');
    const [dateDebutFilter, setDateDebutFilter] = useState('');
    const [dateFinFilter, setDateFinFilter] = useState('');
    const [showFiltres, setShowFiltres] = useState(false);

    const [bookingSelectionne, setBookingSelectionne] = useState({
        id: null,
        reference: '',
        nom_client: '',
        prenom_client: '',
        telephone_client: '',
        email_client: '',
        date_debut: '',
        date_fin: '',
        personnes: '',
        nombre_jours: '',
        statut: ''
    });

    // ============================================
    // FORMATAGE DES DATES
    // ============================================

    const formatDate = (dateStr) => {
        if (!dateStr) return '-';
        try {
            const date = new Date(dateStr);
            if (isNaN(date.getTime())) return dateStr;
            const jour = String(date.getDate()).padStart(2, '0');
            const mois = String(date.getMonth() + 1).padStart(2, '0');
            const annee = date.getFullYear();
            return `${jour}/${mois}/${annee}`;
        } catch (e) {
            return dateStr;
        }
    };

    // ============================================
    // RÉCUPÉRATION DES RÉSERVATIONS
    // ============================================

    const fetchBookings = async () => {
        const token = localStorage.getItem('access_token');
        try {
            setIsLoading(true);

            // Construction de l'URL avec les filtres
            let url = `${process.env.REACT_APP_HOTE}/listes-reservation/`;
            const params = new URLSearchParams();

            if (statutFilter !== 'tous') {
                params.append('statut', statutFilter);
            }
            if (dateDebutFilter) {
                params.append('date_debut', dateDebutFilter);
            }
            if (dateFinFilter) {
                params.append('date_fin', dateFinFilter);
            }

            if (params.toString()) {
                url += `?${params.toString()}`;
            }

            const response = await fetch(`${process.env.REACT_APP_HOTE}/listes-reservation/`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                // body: JSON.stringify({user_id: user_id})
            });

            if (response.ok) {
                const result = await response.json();
                // console.log("Réponse API:", result);

                if (result.success && result.data) {
                    setBooking(result.data);
                } else {
                    console.error("Format de réponse inattendu:", result);
                    setBooking([]);
                }
            } else {
                const errorData = await response.json().catch(() => ({}));
                console.error("Erreur API:", errorData);
                setBooking([]);
                showAlert(errorData.message || "Erreur lors du chargement", "danger");
            }
        } catch (error) {
            console.error("Erreur réseau:", error);
            setBooking([]);
            showAlert("Erreur de connexion au serveur", "danger");
        } finally {
            setIsLoading(false);
        }
    };

    // ============================================
    // GESTIONNAIRES DE FILTRES
    // ============================================

    const handleStatutFilterChange = (e) => {
        setStatutFilter(e.target.value);
        setCurrentPage(1);
    };

    const handleDateDebutFilterChange = (e) => {
        setDateDebutFilter(e.target.value);
        setCurrentPage(1);
    };

    const handleDateFinFilterChange = (e) => {
        setDateFinFilter(e.target.value);
        setCurrentPage(1);
    };

    const resetFilters = () => {
        setStatutFilter('tous');
        setDateDebutFilter('');
        setDateFinFilter('');
        setSearchTerm('');
        setCurrentPage(1);
    };

    // ============================================
    // CHARGEMENT INITIAL
    // ============================================

    useEffect(() => {
        if (user_id) {
            document.title = "O'MEL Services | Réservations";
            fetchBookings();
        }
    }, [user_id, statutFilter, dateDebutFilter, dateFinFilter]); // Recharger quand les filtres changent

    // ============================================
    // FILTRAGE CLIENT (recherche + statut + dates)
    // ============================================

    const bookingFiltrees = Array.isArray(booking)
        ? booking.filter(item => {
            if (!item) return false;

            // Recherche par texte
            const searchLower = searchTerm.toLowerCase();
            const matchSearch =
                (item.reference || '').toLowerCase().includes(searchLower) ||
                (item.nom_client || '').toLowerCase().includes(searchLower) ||
                (item.prenom_client || '').toLowerCase().includes(searchLower) ||
                (item.telephone_client || '').toLowerCase().includes(searchLower) ||
                (item.email_client || '').toLowerCase().includes(searchLower) ||
                (item.personnes || '').toLowerCase().includes(searchLower) ||
                // (item.nombre_jours || '').toLowerCase().includes(searchLower) ||
                (item.statut || '').toLowerCase().includes(searchLower);

            if (!matchSearch) return false;

            // Filtre par statut (déjà fait au niveau API, mais on garde en sécurité)
            if (statutFilter !== 'tous' && item.statut !== statutFilter) {
                return false;
            }

            // Filtre par date de début
            if (!dateDebutFilter && !dateFinFilter) return true;

            const dateItemDebut = new Date(item.date_debut);
            const dateItemFin = new Date(item.date_fin);

            // Si les deux dates sont fournies
            if (dateDebutFilter && dateFinFilter) {
                const dateFilterDebut = new Date(dateDebutFilter);
                const dateFilterFin = new Date(dateFinFilter);

                // Chevauchement : la réservation commence avant la fin de la période ET finit après le début de la période
                return dateItemDebut <= dateFilterFin && dateItemFin >= dateFilterDebut;
            }

            // Si seule la date de début est fournie
            if (dateDebutFilter) {
                const dateFilterDebut = new Date(dateDebutFilter);
                // La réservation finit après la date de début du filtre
                return dateItemFin >= dateFilterDebut;
            }

            // Si seule la date de fin est fournie
            if (dateFinFilter) {
                const dateFilterFin = new Date(dateFinFilter);
                // La réservation commence avant la date de fin du filtre
                return dateItemDebut <= dateFilterFin;
            }

            return true;
        })
        : [];

    // ============================================
    // TRI
    // ============================================

    const bookingTriees = [...bookingFiltrees].sort((a, b) => {
        if (sortConfig.key) {
            const valueA = (a[sortConfig.key] || '').toString().toLowerCase();
            const valueB = (b[sortConfig.key] || '').toString().toLowerCase();
            if (valueA < valueB) return sortConfig.direction === "ascending" ? -1 : 1;
            if (valueA > valueB) return sortConfig.direction === "ascending" ? 1 : -1;
        }
        return 0;
    });

    // ============================================
    // PAGINATION
    // ============================================

    const totalItems = bookingFiltrees.length;
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const bookingAffichees = bookingTriees.slice(indexOfFirstItem, indexOfLastItem);

    // ============================================
    // GESTION DES ACTIONS
    // ============================================

    const handleSort = (key) => {
        let direction = "ascending";
        if (sortConfig.key === key && sortConfig.direction === "ascending") {
            direction = "descending";
        }
        setSortConfig({ key, direction });
    };

    const handleItemsPerPageChange = (e) => {
        setItemsPerPage(Number(e.target.value));
        setCurrentPage(1);
    };

    const showAlert = (message, type = 'success') => {
        setAlert({ message, type });
        // setTimeout(() => {
        //     setAlert({ message: '', type: '' });
        // }, 5000);
    };

    const showAlertModal = (message, type = 'success') => {
        setAlertModal({ message, type });
    };

    const fermerNotif = () => {
        setAlert({ message: '', type: '' });
        setAlertModal({ message: '', type: '' });
    };

    // ============================================
    // ANNULATION
    // ============================================

    const handleShowDeleteModal = (bookingItem) => {
        setBookingSelectionne(bookingItem);
        setShowDeleteModal(true);
    };

    const handleCloseDeleteModal = () => {
        setShowDeleteModal(false);
        setBookingSelectionne(null);
    };

    const handleAnnulerBooking = async () => {
        if (!bookingSelectionne || !bookingSelectionne.id) {
            showAlert("Aucune réservation sélectionnée", "danger");
            return;
        }

        const token = localStorage.getItem('access_token');
        try {
            const response = await fetch(`${process.env.REACT_APP_HOTE}/annuler-reservation-client/${bookingSelectionne.id}/`,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                    body: JSON.stringify({ motif: "Annulation par le client" })
                }
            );

            const result = await response.json();

            if (response.ok) {
                setShowDeleteModal(false);
                showAlert('Réservation annulée avec succès !', "success");
                setTimeout(() => {
                    setAlert({ message: '', type: '' });
                }, 2000);
                await fetchBookings();
                return { success: true };
            } else {
                const errorMsg = result.error || result.message || "Erreur lors de l'annulation";
                showAlert(errorMsg, 'danger');
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
            showAlert('Erreur réseau', 'danger');
        } finally {
            setShowDeleteModal(false);
            setBookingSelectionne(null);
        }
    };

    // ============================================
    // MODIFICATION
    // ============================================

    const handleShowModifierModal = (bookingItem) => {
        setBookingSelectionne(bookingItem);
        setShowModifierModal(true);
    };

    const handleCloseModifierModal = () => {
        setShowModifierModal(false);
        setBookingSelectionne(null);
    };

    const handleModifierBooking = async () => {
        if (!bookingSelectionne || !bookingSelectionne.id) {
            showAlert("Aucune réservation sélectionnée", "danger");
            return;
        }

        const erreurs = [];

        if (erreurs.length > 0) {
            showAlertModal(erreurs.join(" "), "danger");
            return;
        }

        // Préparer les données avec les dates formatées
        const updateData = {
            nom_client: bookingSelectionne.nom_client,
            prenom_client: bookingSelectionne.prenom_client,
            telephone_client: bookingSelectionne.telephone_client,
            email_client: bookingSelectionne.email_client || '',
        };

        // Si de nouvelles dates ont été définies, les formater
        if (bookingSelectionne.new_date_debut) {
            updateData.date_debut = new Date(bookingSelectionne.new_date_debut).toISOString();
        } else if (bookingSelectionne.date_debut) {
            // Si pas de nouvelle date, utiliser l'ancienne mais au bon format
            updateData.date_debut = new Date(bookingSelectionne.date_debut).toISOString();
        }

        if (bookingSelectionne.new_date_fin) {
            updateData.date_fin = new Date(bookingSelectionne.new_date_fin).toISOString();
        } else if (bookingSelectionne.date_fin) {
            updateData.date_fin = new Date(bookingSelectionne.date_fin).toISOString();
        }

        const token = localStorage.getItem('access_token');
        try {
            const response = await fetch(`${process.env.REACT_APP_HOTE}/modifier-reservation-client/${bookingSelectionne.id}/`,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                    body: JSON.stringify(updateData),
                }
            );

            const result = await response.json();

            if (response.ok) {
                setShowModifierModal(false);
                showAlert('Réservation modifiée avec succès !', "success");
                setTimeout(() => {
                    setAlert({ message: '', type: '' });
                }, 2000);
                await fetchBookings();
                return { success: true };
            } else {
                const errorMsg = result.error || result.message || "Erreur lors de la modification";
                showAlert(errorMsg, 'danger');
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
            showAlert('Erreur réseau', 'danger');
        } finally {
            setShowModifierModal(false);
        }
    };

    // Fonction d'export
    // const exportReservations = async () => {

    //     const token = localStorage.getItem('access_token');
    //     try {
    //         const response = await fetch(`${process.env.REACT_APP_HOTE}/export-reservations/`, {
    //             method: 'GET',
    //             headers: {
    //                 'Content-Type': 'application/json',
    //                 'Authorization': `Bearer ${token}`
    //             },
    //             body: JSON.stringify(),
    //         });

    //         if (response.ok) {
    //             // Créer un blob pour le téléchargement
    //             const blob = await response.blob();
    //             const url = window.URL.createObjectURL(blob);
    //             const link = document.createElement('a');
    //             link.href = url;

    //             // Extraire le nom du fichier depuis le header Content-Disposition
    //             const contentDisposition = response.headers.get('Content-Disposition');
    //             let filename = 'reservations.xlsx';
    //             if (contentDisposition) {
    //                 const match = contentDisposition.match(/filename="(.+)"/);
    //                 if (match) filename = match[1];
    //             }

    //             link.download = filename;
    //             document.body.appendChild(link);
    //             link.click();
    //             document.body.removeChild(link);
    //             window.URL.revokeObjectURL(url);

    //             showAlert('Export réussi !', 'success');
    //         } else {
    //             const error = await response.text();
    //             showAlert(`Erreur: ${error}`, 'danger');
    //         }
    //     } catch (error) {
    //         console.error('Erreur export:', error);
    //         showAlert('Erreur réseau', 'danger');
    //     }
    // };

    // ============================================
    // EXPORT DES RÉSERVATIONS AVEC FILTRES
    // ============================================

    const exportReservations = async () => {
        const token = localStorage.getItem('access_token');

        try {
            // Construire l'URL avec les paramètres de filtres
            let url = `${process.env.REACT_APP_HOTE}/export-reservations/`;
            const params = new URLSearchParams();

            // Ajouter les filtres de dates si présents
            if (dateDebutFilter) {
                params.append('date_debut', dateDebutFilter);
            }
            if (dateFinFilter) {
                params.append('date_fin', dateFinFilter);
            }

            // Ajouter le filtre de statut (si votre backend le supporte)
            if (statutFilter !== 'tous') {
                params.append('statut', statutFilter);
            }

            // Ajouter les paramètres à l'URL
            if (params.toString()) {
                url += `?${params.toString()}`;
            }

            // console.log('URL d\'export:', url);
            // console.log('Filtres appliqués:', {
            //     date_debut: dateDebutFilter || '',
            //     date_fin: dateFinFilter || '',
            //     // statut: statutFilter || 'Tous'
            // });

            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            });

            if (response.ok) {
                // Créer un blob pour le téléchargement
                const blob = await response.blob();
                const urlBlob = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = urlBlob;

                // Extraire le nom du fichier depuis le header Content-Disposition
                const contentDisposition = response.headers.get('Content-Disposition');
                let filename = 'reservations.xlsx';
                if (contentDisposition) {
                    const match = contentDisposition.match(/filename="(.+)"/);
                    if (match) {
                        filename = match[1];
                        // Ajouter les filtres au nom du fichier si présent
                    } else {
                        // Générer un nom avec les filtres
                        let nameParts = ['reservations'];
                        if (dateDebutFilter) nameParts.push(`du_${dateDebutFilter}`);
                        if (dateFinFilter) nameParts.push(`au_${dateFinFilter}`);
                        if (statutFilter !== 'tous') nameParts.push(statutFilter);
                        filename = `${nameParts.join('_')}.xlsx`;
                    }
                }

                link.download = filename;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(urlBlob);

                // Message de succès avec les filtres appliqués
                let message = 'Export réussi !';
                if (dateDebutFilter || dateFinFilter) {
                    let periode = '';
                    if (dateDebutFilter) periode += ` du ${formatDate(dateDebutFilter)}`;
                    if (dateFinFilter) periode += ` au ${formatDate(dateFinFilter)}`;
                    message += ` pour la période${periode}`;
                }
                // if (statutFilter !== 'tous') {
                //     message += ` (statut: ${statutFilter === 'reserver' ? 'Réservé' :
                //         statutFilter === 'encours' ? 'En cours' :
                //             statutFilter === 'termine' ? 'Terminé' :
                //                 statutFilter === 'annule' ? 'Annulé' : statutFilter})`;
                // }
                showAlert(message, 'success');
                setTimeout(() => {
                    setAlert({ message: '', type: '' });
                }, 2000);

            } else {
                const error = await response.text();
                showAlert(`Erreur lors de l'export: ${error}`, 'danger');
            }
        } catch (error) {
            console.error('Erreur export:', error);
            showAlert('Erreur réseau lors de l\'export', 'danger');
        }
    };

    // ============================================
    // RENDU
    // ============================================

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2 className="d-flex justify-content-between align-items-center">
                                <div className="d-flex align-items-center">
                                    <FaCalendarCheck size={25} className='mr-2' />
                                    Réservations
                                </div>
                            </h2>
                            <small>Administration des réservations.</small>
                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item active">
                                        Réservations
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>

                    {alert.message && (
                        <div className={`m-3 alert alert-${alert.type} row justify-content-between position-relative`}>
                            <div dangerouslySetInnerHTML={{ __html: alert.message }} />
                            <span
                                onClick={fermerNotif}
                                style={{
                                    position: 'absolute',
                                    top: '0px',
                                    right: '10px',
                                    cursor: 'pointer'
                                }}
                            >
                                <i className='fa fa-close'></i>
                            </span>
                        </div>
                    )}

                    <div className="wrapper wrapper-content animated fadeInRight mt-3">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h5>Liste des réservations ({bookingFiltrees.length})</h5>

                            <div className="d-flex mt-md-0" style={{ gap: '10px' }}>
                                <button
                                    className="btn btn-outline-primary d-flex align-items-center"
                                    onClick={() => setShowFiltres(!showFiltres)}
                                >
                                    <FaFilter className="mr-1" />
                                    {showFiltres ? 'Masquer les filtres' : 'Afficher les filtres'}
                                </button>
                                <button className="btn btn-success mr-2 d-flex align-items-center justify-content-center" onClick={exportReservations}>
                                    <FaFileExport />
                                    <span className="d-none d-sm-inline ml-2">Exporter</span>
                                </button>

                            </div>
                        </div>

                        {/* SECTION FILTRES */}
                        {showFiltres && (
                            <div className="row mb-3 p-3" style={{ backgroundColor: '#f8f9fa', borderRadius: '8px' }}>

                                <div className="col-md-3">
                                    <label className="form-label fw-bold">Date d'arrivée (début)</label>
                                    <input
                                        type="date"
                                        value={dateDebutFilter}
                                        onChange={handleDateDebutFilterChange}
                                        className="form-control"
                                    />
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label fw-bold">Date de départ (fin)</label>
                                    <input
                                        type="date"
                                        value={dateFinFilter}
                                        onChange={handleDateFinFilterChange}
                                        className="form-control"
                                    />
                                </div>
                                <div className="col-md-3 d-flex align-items-end">
                                    <button
                                        className="btn btn-secondary"
                                        onClick={resetFilters}
                                    >
                                        Réinitialiser les filtres
                                    </button>
                                </div>
                            </div>
                        )}

                        <div className="row">
                            <div className="col-lg-12">
                                <div className="ibox">
                                    <div className="ibox-content">
                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                            <div className="d-flex flex-wrap align-items-center mb-2 mb-md-0 gap-md-3">
                                                <div className="me-4 mb-2 mb-md-0 mr-2">
                                                    <select
                                                        value={itemsPerPage}
                                                        onChange={handleItemsPerPageChange}
                                                        className="form-select bg-default p-1"
                                                        style={{
                                                            width: "auto",
                                                            border: "1px black solid",
                                                            borderRadius: "5px",
                                                        }}
                                                    >
                                                        <option value={10}>10</option>
                                                        <option value={20}>20</option>
                                                        <option value={50}>50</option>
                                                    </select>
                                                </div>

                                                <div className="me-4 mb-2 mr-2 mb-md-0">
                                                    <select
                                                        value={statutFilter}
                                                        onChange={handleStatutFilterChange}
                                                        className="form-select bg-default p-1"
                                                    >
                                                        <option value="tous">Tous les statuts</option>
                                                        <option value="reserver">Réservé</option>
                                                        <option value="encours">En cours</option>
                                                        <option value="termine">Terminé</option>
                                                        <option value="annule">Annulé</option>
                                                    </select>
                                                </div>
                                            </div>

                                            <div className="row justify-content-center align-items-center">
                                                <input
                                                    type="text"
                                                    placeholder="Rechercher..."
                                                    className="form-control mr-2"
                                                    style={{ maxWidth: "200px", width: "100%" }}
                                                    value={searchTerm}
                                                    onChange={(e) => setSearchTerm(e.target.value)}
                                                />
                                            </div>
                                        </div>

                                        <div className="table-responsive">
                                            <table className="footable table table-stripped footable-loaded tablet breakpoint">
                                                <thead>
                                                    <tr>
                                                        <th className="text-secondary text-wrap d-none d-md-table-cell text-justify" onClick={() => handleSort("reference")}>
                                                            Référence
                                                            {sortConfig.key === "reference" &&
                                                                (sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                        </th>
                                                        <th className="text-secondary text-wrap d-none d-md-table-cell text-center" onClick={() => handleSort("nom_client")}>
                                                            Nom client
                                                            {sortConfig.key === "nom_client" &&
                                                                (sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                        </th>
                                                        <th className="text-secondary text-wrap d-none d-md-table-cell text-center" onClick={() => handleSort("telephone_client")}>
                                                            Téléphone
                                                            {sortConfig.key === "telephone_client" &&
                                                                (sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                        </th>
                                                        <th className="text-secondary text-wrap d-none d-md-table-cell text-center" onClick={() => handleSort("email_client")}>
                                                            Email
                                                            {sortConfig.key === "email_client" &&
                                                                (sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                        </th>
                                                        <th className="text-secondary text-wrap d-none d-md-table-cell text-center" onClick={() => handleSort("date_debut")}>
                                                            Arrivée
                                                            {sortConfig.key === "date_debut" &&
                                                                (sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                        </th>
                                                        <th className="text-secondary text-wrap d-none d-md-table-cell text-center" onClick={() => handleSort("date_fin")}>
                                                            Départ
                                                            {sortConfig.key === "date_fin" &&
                                                                (sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                        </th>
                                                        <th className="text-secondary text-wrap d-none d-md-table-cell text-center" onClick={() => handleSort("personnes")}>
                                                            Personnes
                                                            {sortConfig.key === "personnes" &&
                                                                (sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                        </th>
                                                        <th className="text-secondary text-wrap d-none d-md-table-cell text-center" onClick={() => handleSort("nombre_jours")}>
                                                            Nombre de jours
                                                            {sortConfig.key === "nombre_jours" &&
                                                                (sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                        </th>
                                                        <th className="text-secondary text-wrap d-none d-md-table-cell text-center" onClick={() => handleSort("statut")}>
                                                            Statut
                                                            {sortConfig.key === "statut" &&
                                                                (sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                        </th>
                                                        <th className="text-center">Actions</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {isLoading ? (
                                                        <tr>
                                                            <td colSpan="9" className="text-center">Chargement...</td>
                                                        </tr>
                                                    ) : bookingAffichees.length > 0 ? (
                                                        bookingAffichees.map((item) => (
                                                            <tr key={item.id}>
                                                                <td className="d-none d-md-table-cell text-justify">{item.reference}</td>
                                                                <td className="d-none d-md-table-cell text-center">{item.nom_client} {item.prenom_client}</td>
                                                                <td className="d-none d-md-table-cell text-center">{item.telephone_client}</td>
                                                                <td className="d-none d-md-table-cell text-center">{item.email_client}</td>
                                                                <td className="d-none d-md-table-cell text-center">
                                                                    {formatDate(item.date_debut)}
                                                                </td>
                                                                <td className="d-none d-md-table-cell text-center">
                                                                    {formatDate(item.date_fin)}
                                                                </td>
                                                                <td className="d-none d-md-table-cell text-center">{item.personnes}</td>
                                                                <td className="d-none d-md-table-cell text-center">{item.nombre_jours}</td>
                                                                <td className="d-none d-md-table-cell text-center">
                                                                    <span className={`badge ${item.statut === 'reserver' ? 'badge-primary' :
                                                                        item.statut === 'encours' ? 'badge-warning' :
                                                                            item.statut === 'termine' ? 'badge-success' :
                                                                                'badge-danger'}`}>
                                                                        {item.statut === 'reserver' ? 'Réservé' :
                                                                            item.statut === 'encours' ? 'En cours' :
                                                                                item.statut === 'termine' ? 'Terminé' :
                                                                                    item.statut === 'annule' ? 'Annulé' :
                                                                                        item.statut}
                                                                    </span>
                                                                </td>
                                                                <td className="text-center" style={{ position: 'relative' }}>
                                                                    <button
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            setOpenDropdownId(openDropdownId === item.id ? null : item.id);
                                                                        }}
                                                                        style={{
                                                                            background: 'none',
                                                                            border: 'none',
                                                                            padding: '0 5px',
                                                                            cursor: 'pointer'
                                                                        }}
                                                                    >
                                                                        <FaEllipsisV title="Actions" />
                                                                    </button>

                                                                    {openDropdownId === item.id && (
                                                                        <div
                                                                            style={{
                                                                                position: 'fixed',
                                                                                zIndex: 1000,
                                                                                minWidth: '150px',
                                                                                right: '100px',
                                                                                backgroundColor: 'white',
                                                                                border: '1px solid #ddd',
                                                                                borderRadius: '4px',
                                                                                boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
                                                                                maxHeight: '150px',
                                                                                overflowY: 'auto',
                                                                            }}
                                                                        >
                                                                            {/* Fonction pour afficher les actions selon le statut */}
                                                                            {item.statut === 'reserver' && (
                                                                                <>
                                                                                    <div
                                                                                        style={{
                                                                                            padding: '8px 16px',
                                                                                            display: 'flex',
                                                                                            alignItems: 'center',
                                                                                            cursor: 'pointer',
                                                                                        }}
                                                                                        onClick={() => {
                                                                                            handleShowModifierModal(item);
                                                                                            setOpenDropdownId(null);
                                                                                        }}
                                                                                        onMouseEnter={(e) => e.target.style.backgroundColor = '#f8f9fa'}
                                                                                        onMouseLeave={(e) => e.target.style.backgroundColor = 'white'}
                                                                                    >
                                                                                        <FaEdit className="mr-2" style={{ color: "blue" }} size={14} />
                                                                                        <span>Modifier</span>
                                                                                    </div>
                                                                                    <div style={{ borderTop: '1px solid #eee' }} />
                                                                                    <div
                                                                                        style={{
                                                                                            padding: '8px 16px',
                                                                                            display: 'flex',
                                                                                            alignItems: 'center',
                                                                                            cursor: 'pointer',
                                                                                        }}
                                                                                        onClick={() => {
                                                                                            handleShowDeleteModal(item);
                                                                                            setOpenDropdownId(null);
                                                                                        }}
                                                                                        onMouseEnter={(e) => e.target.style.backgroundColor = '#f8f9fa'}
                                                                                        onMouseLeave={(e) => e.target.style.backgroundColor = 'white'}
                                                                                    >
                                                                                        <FaTimes className="mr-2" style={{ color: "red" }} size={14} />
                                                                                        <span>Annuler</span>
                                                                                    </div>
                                                                                </>
                                                                            )}

                                                                            {item.statut === 'encours' && (
                                                                                <div
                                                                                    style={{
                                                                                        padding: '8px 16px',
                                                                                        display: 'flex',
                                                                                        alignItems: 'center',
                                                                                        cursor: 'pointer',
                                                                                    }}
                                                                                    onClick={() => {
                                                                                        handleShowModifierModal(item);
                                                                                        setOpenDropdownId(null);
                                                                                    }}
                                                                                    onMouseEnter={(e) => e.target.style.backgroundColor = '#f8f9fa'}
                                                                                    onMouseLeave={(e) => e.target.style.backgroundColor = 'white'}
                                                                                >
                                                                                    <FaEdit className="mr-2" style={{ color: "blue" }} size={14} />
                                                                                    <span>Modifier</span>
                                                                                </div>
                                                                            )}

                                                                            {item.statut === 'annule' && (
                                                                                <div
                                                                                    style={{
                                                                                        padding: '8px 16px',
                                                                                        textAlign: 'center',
                                                                                        color: '#6c757d',
                                                                                        fontStyle: 'italic',
                                                                                        fontSize: '13px'
                                                                                    }}
                                                                                >
                                                                                    <FaTimes className="mr-2" style={{ color: "#6c757d" }} size={14} />
                                                                                    <span>Déjà annulée</span>
                                                                                </div>
                                                                            )}

                                                                            {item.statut === 'termine' && (
                                                                                <div
                                                                                    style={{
                                                                                        padding: '8px 16px',
                                                                                        textAlign: 'center',
                                                                                        color: '#6c757d',
                                                                                        fontStyle: 'italic',
                                                                                        fontSize: '13px'
                                                                                    }}
                                                                                >
                                                                                    <FaCheck className="mr-2" style={{ color: "#28a745" }} size={14} />
                                                                                    <span>Déjà terminée</span>
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    )}
                                                                </td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="9" className="text-center">
                                                                {searchTerm || statutFilter !== 'tous' || dateDebutFilter || dateFinFilter
                                                                    ? "Aucune réservation correspondant aux filtres"
                                                                    : "Aucune réservation"}
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>

                                        {/* Pagination */}
                                        <div className="d-flex justify-content-between align-items-center mt-3">
                                            <div>
                                                {bookingFiltrees.length === 0
                                                    ? "Aucun élément à afficher"
                                                    : `Affichage de ${indexOfFirstItem + 1} à ${Math.min(indexOfLastItem, bookingFiltrees.length)} sur ${bookingFiltrees.length}`}
                                            </div>
                                            <div className="d-flex align-items-center">
                                                <button
                                                    onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                                                    className={`btn ${currentPage === 1 ? "btn-outline-secondary" : "btn-outline-primary"} mx-1`}
                                                    disabled={currentPage === 1}
                                                >
                                                    <FaArrowLeft />
                                                </button>

                                                {(() => {
                                                    const pagesToShow = 5;
                                                    let startPage = Math.max(1, currentPage - Math.floor(pagesToShow / 2));
                                                    let endPage = Math.min(totalPages, startPage + pagesToShow - 1);

                                                    if (endPage - startPage < pagesToShow - 1) {
                                                        startPage = Math.max(1, endPage - pagesToShow + 1);
                                                    }

                                                    const pageButtons = [];
                                                    for (let i = startPage; i <= endPage; i++) {
                                                        pageButtons.push(
                                                            <button
                                                                key={i}
                                                                onClick={() => setCurrentPage(i)}
                                                                className={`btn ${currentPage === i ? "btn-default" : "btn-light"} mx-1`}
                                                            >
                                                                {i}
                                                            </button>
                                                        );
                                                    }
                                                    return pageButtons;
                                                })()}

                                                <button
                                                    onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                                                    className={`btn ${currentPage === totalPages ? "btn-outline-secondary" : "btn-outline-primary"} mx-1`}
                                                    disabled={currentPage === totalPages}
                                                >
                                                    <FaArrowRight />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Modal de confirmation de suppression */}
            <Modal show={showDeleteModal} onHide={handleCloseDeleteModal}>
                <Modal.Header>
                    <Modal.Title>Confirmer l'annulation</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Êtes-vous sûr de vouloir annuler cette réservation ?</p>
                    {bookingSelectionne && (
                        <div className="mt-2">
                            <p><strong>Client :</strong> {bookingSelectionne.nom_client} {bookingSelectionne.prenom_client}</p>
                            <p><strong>Référence :</strong> {bookingSelectionne.reference}</p>
                            <p><strong>Dates :</strong> {formatDate(bookingSelectionne.date_debut)} → {formatDate(bookingSelectionne.date_fin)}</p>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseDeleteModal}>
                        <strong>Fermer</strong>
                    </Button>
                    <Button variant="danger" onClick={handleAnnulerBooking}>
                        <strong>Confirmer l'annulation</strong>
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Modal de Modification de réservation */}
            <Modal show={showModifierModal} onHide={handleCloseModifierModal} >
                <Modal.Header >
                    <Modal.Title>
                        <FaEdit className="mr-2" />
                        Modifier la réservation
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    <div className="extension-info">
                        <p><strong>Client:</strong> {bookingSelectionne?.prenom_client} {bookingSelectionne?.nom_client}</p>
                        <p><strong>Chambre:</strong> {bookingSelectionne?.chambre?.nom || ''}</p>
                        <p><strong>Séjour actuel:</strong> {formatDate(bookingSelectionne?.date_debut)} → {formatDate(bookingSelectionne?.date_fin)}</p>
                        <p><strong>Référence:</strong> {bookingSelectionne?.reference}</p>
                    </div>

                    <hr className="my-3" />

                    <div className="form-row">
                        <div className="form-group">
                            <label>Nouvelle date d'arrivée <span style={{ color: 'red' }}>*</span></label>
                            <input
                                type="date"
                                name="date_debut"
                                required
                                value={bookingSelectionne?.date_debut.split('T')[0]}
                                // min={bookingSelectionne?.date_debut.split('T')[0]}
                                className="form-input"
                                onChange={(e) =>
                                    setBookingSelectionne({ ...bookingSelectionne, date_debut: e.target.value })
                                }
                                disabled={bookingSelectionne?.statut === 'encours'}
                            />
                        </div>
                        <div className="form-group">
                            <label>Nouvelle date de départ <span style={{ color: 'red' }}>*</span></label>
                            <input
                                type="date"
                                name="date_fin"
                                required
                                value={bookingSelectionne?.date_fin.split('T')[0]}
                                min={bookingSelectionne?.date_debut.split('T')[0]}
                                className="form-input"
                                onChange={(e) =>
                                    setBookingSelectionne({ ...bookingSelectionne, date_fin: e.target.value })
                                }
                            />
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModifierModal}>
                        <strong>Fermer</strong>
                    </Button>
                    <Button variant="success" onClick={handleModifierBooking}>
                        <strong>Modifier</strong>
                    </Button>
                </Modal.Footer>
            </Modal>

        </div>
    );
};

export default Reservation;